module.exports = __webpack_public_path__ + "static/business-terms-460745b46b132add730097376e3e0109.png";